import SetNameAndPass from './SetNameAndPass';
export default SetNameAndPass;